import { Flex, FlexProps } from '@chakra-ui/react'
import React from 'react'

import { IconCircleAlert } from '~shared-components/icons/brand/IconCircleAlert'

interface ErrorBoundaryProps {
  showFeedbackButton?: boolean
  showIcon?: boolean
}

const ErrorLayout: React.FC<FlexProps> = props => (
  <Flex alignItems="center" flexGrow={1} {...props} />
)

const sxErrorContainer = {
  '& > svg': {
    marginRight: '15px',
  },
}

const ErrorContainer: React.FC<FlexProps> = props => (
  <Flex
    alignItems="center"
    color="red.70"
    flex="1 1 auto"
    height="100%"
    justifyContent="center"
    sx={sxErrorContainer}
    {...props}
  />
)

export const ErrorBoundary: React.FC<ErrorBoundaryProps> = ({
  showIcon = true,
}) => (
  <ErrorLayout>
    <ErrorContainer>
      {showIcon && <IconCircleAlert boxSize="28px" color="red.70" />}
      Something has gone wrong.
    </ErrorContainer>
  </ErrorLayout>
)
